import "../playerList/index.scss";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";

import AppShell from "../../components/appShell";
import ViewPlayers from "../../components/viewPlayers";
import {
  BiddingBlocks,
  activeBlock as getActiveBlock,
  selectbiddingBlocks,
  selectactiveBlock,
  selectBlocksLoading,
} from "../../store/features/generalSlice";
import { useSocketRoom } from "../../hooks/useSocketRoom";

// The public list. Nobody is signed in, so the shell shows the top bar and no
// rail, and every request goes through the session-scoped public endpoints
// rather than the bidder's own - which is what lets the live board link
// straight here without asking anyone to log in.
const AllPlayersListGeneral = ({ socket }) => {
  const { sessionId } = useParams();
  const [key, setKey] = useState("elite");
  const biddingBlocks = useSelector(selectbiddingBlocks);
  const activeBlock = useSelector(selectactiveBlock);
  const loading = useSelector(selectBlocksLoading);
  const dispatch = useDispatch();

  // Rejoins on every reconnect, so a dropped socket recovers on its own.
  useSocketRoom(socket, { role: "public", id: null, sessionId: sessionId });

  useEffect(() => {
    if (!sessionId) return;
    dispatch(BiddingBlocks(sessionId));
    dispatch(getActiveBlock(sessionId));
  }, [sessionId]);

  // The board pushes an event on every sale, so the list follows the room
  // instead of going stale behind it.
  useEffect(() => {
    if (!sessionId || !socket) return;

    const refresh = () => {
      dispatch(BiddingBlocks(sessionId));
      dispatch(getActiveBlock(sessionId));
    };

    // Joining is handled by useSocketRoom, which also survives a reconnect.
    socket.on("set-player-sold", refresh);
    socket.on("set-player-unsold", refresh);
    socket.on("block-finished", refresh);
    socket.on("block-started", refresh);
  }, [sessionId]);

  if (!sessionId) {
    return (
      <AppShell role="public" label="Auction Pool">
        <h1 className="au-heading">Auction Pool</h1>
        <p className="au-subheading">
          Open this page from the live board, or use the link the organiser sent
          you. It needs an auction to show.
        </p>
      </AppShell>
    );
  }

  return (
    <AppShell
      role="public"
      label="Auction Pool"
      aside={
        <>
          <Link className="au-btn ghost small" to={`/teams/${sessionId}`}>
            Teams
          </Link>
          <Link className="au-btn ghost small" to={`/live/${sessionId}`}>
            Back to the live board
          </Link>
        </>
      }
    >
      <div className="player-list">
        <header className="player-list-head">
          <div>
            <h1 className="au-heading">Auction Pool</h1>
            <p className="au-subheading">
              Every player up for auction, and what they went for.
              {activeBlock?.playerType
                ? ` ${activeBlock.playerType.trim()} is on the block now.`
                : ""}
            </p>
          </div>
        </header>

        <ViewPlayers
          blocks={biddingBlocks}
          keyState={{ key, setKey }}
          loading={loading}
        />
      </div>
    </AppShell>
  );
};

export default AllPlayersListGeneral;
